import { ArrowDownIcon, SparkleIcon } from "@phosphor-icons/react";
import { motion } from "framer-motion";

type Props = {
  balance: number;
  loading: boolean;
  onViewPacks: () => void;
};

export const CreditsHero = ({ balance, loading, onViewPacks }: Props) => (
  <motion.header
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3, ease: "easeOut" }}
    className="relative overflow-hidden rounded-2xl border border-indigo-100 bg-white px-5 py-5 shadow-[0_10px_35px_rgba(30,27,75,0.06)] sm:px-7 sm:py-6"
  >
    <div
      aria-hidden
      className="absolute -right-14 -top-20 size-56 rounded-full bg-violet-100/70 blur-2xl"
    />
    <div
      aria-hidden
      className="absolute -bottom-24 right-24 size-44 rounded-full bg-emerald-100/60 blur-3xl"
    />

    <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="max-w-xl">
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-emerald-600">
          <SparkleIcon size={14} weight="fill" /> Assistant IA
        </p>
        <h1 className="mt-2 text-2xl font-bold tracking-tight text-[#071451] sm:text-[30px]">
          Vos crédits IA
        </h1>
        <p className="mt-1.5 max-w-lg text-xs leading-5 text-indigo-950/65 sm:text-sm">
          Activez les suggestions, traductions et analyses qui vous aident à améliorer votre
          candidature.
        </p>
      </div>

      <div className="flex min-w-[220px] items-center justify-between gap-5 rounded-xl border border-indigo-100 bg-indigo-50/55 px-4 py-3.5 sm:block sm:text-right">
        <div>
          <p className="text-[9px] font-bold uppercase tracking-[0.12em] text-indigo-700/65">
            Solde disponible
          </p>
          <p className="mt-0.5 text-2xl font-bold tabular-nums text-[#071451]">
            {loading ? "…" : balance.toLocaleString("fr-FR")}
            <span className="ml-1 text-xs font-semibold text-indigo-700/60">crédits</span>
          </p>
        </div>
        <button
          type="button"
          onClick={onViewPacks}
          className="mt-0 inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-indigo-700 text-white shadow-sm transition hover:-translate-y-0.5 hover:bg-indigo-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 sm:mt-2 sm:size-auto sm:min-h-8 sm:px-3 sm:text-[10px] sm:font-bold"
        >
          <span className="hidden sm:inline">Recharger</span>
          <ArrowDownIcon size={14} weight="bold" className="sm:ml-1" />
        </button>
      </div>
    </div>
  </motion.header>
);
